import { get, patch, del } from './client'
import type { User, UpdateProfileData } from '../types'

/**
 * Fetch the currently authenticated user's profile.
 */
export async function getProfile(): Promise<User> {
  return get<User>('/app/users/profile')
}

/**
 * Update a user's profile fields using JSON Merge Patch.
 * The Content-Type header is set to application/merge-patch+json automatically
 * by the `patch` helper in client.ts.
 */
export async function updateProfile(id: number, data: UpdateProfileData): Promise<User> {
  return patch<User>(`/app/users/${id}`, data)
}

/**
 * Permanently delete a user account.
 * Returns void — the server responds with 204 No Content on success.
 */
export async function deleteAccount(id: number): Promise<void> {
  return del<void>(`/app/users/${id}`)
}
